import { render, staticRenderFns } from "./QuestionPoolsIndex.vue?vue&type=template&id=277e4aa8"
import script from "./QuestionPoolsIndex.vue?vue&type=script&lang=js"
export * from "./QuestionPoolsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports